import React, { useState, useEffect } from 'react';

const Hero = () => {
  const [offsetY, setOffsetY] = useState(0);
  const handleScroll = () => setOffsetY(window.pageYOffset);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className='home-hero-block'>
      <div className='hero-text-block'>
        <div
          style={{
            transform: `translateY(${
              window.innerWidth > 500 ? offsetY * 0.42 : offsetY * 0.48
              }px)
              scale(${1 - offsetY * 0.0002})`,
          }}
        >
          {/* scale(${1-offsetY * 0.0004}) */}
          <h1>Fizz it up.</h1>
        </div>

        <div
          className='hero-pic-block'
          style={{
            transform: `translateY(${
              window.innerWidth > 500 ? offsetY * 0.26 : offsetY * 0.35
            }px)`,
          }}
        >
          <img src='/img/product-mini.png' alt='' />
          <div className='shadowz'></div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
